import React, { useRef } from 'react';
import { content } from '../data/content';
import { useReveal } from '../hooks/useReveal';

const Awards = ({ language }) => {
    const t = content[language].awards;
    const root = useRef(null);

    useReveal(root);

    return (
        <div ref={root} className="min-h-screen pt-24 pb-16 px-4 container mx-auto">
            <h1 className="reveal text-4xl font-bold text-center mb-12 text-gray-800 dark:text-white">
                {t.title}
            </h1>

            <div className="max-w-4xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                {t.items.map((award, index) => (
                    <div
                        key={index}
                        className="reveal-card bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 border-t-4 border-yellow-500"
                    >
                        <div className="flex items-center justify-center w-12 h-12 bg-yellow-100 dark:bg-yellow-900/30 rounded-full mb-4 mx-auto text-yellow-600 dark:text-yellow-400">
                            <i className={`${award.icon} text-xl`}></i>
                        </div>
                        <h3 className="text-xl font-bold text-center text-gray-800 dark:text-white mb-2">
                            {award.title}
                        </h3>
                        <p className="text-center text-blue-600 dark:text-blue-400 font-medium mb-2 text-sm">
                            {award.org}
                        </p>
                        <p className="text-center text-gray-600 dark:text-gray-400 text-sm">
                            {award.desc}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Awards;
